/**
 * Util function to replace or append an item in array.
 */
export const replaceOrAppend = <T extends unknown>(
  array: T[] | readonly T[],
  predicate: (item: T) => boolean,
  item: T,
): T[] => {
  const index = array.findIndex(predicate);

  if (index < 0) {
    return [...array, item];
  }

  return [...array.slice(0, index), item, ...array.slice(index + 1)];
};
